import React from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useAppSelector } from "@temp/redux";
import { useCategoriesSubCategories, useQuerySaleCategoriesSubcategories } from "../hooks";
import { AlertFilters } from "../AlertFilters";
export var AlertFiltersSale = function AlertFiltersSale(_ref) {
  var hideModal = _ref.hideModal;

  var _useParams = useParams(),
      id = _useParams.id;

  var intl = useIntl();

  var _useAppSelector = useAppSelector(function (state) {
    return state.search;
  }),
      searchCategory = _useAppSelector.searchCategory,
      searchSubcategory = _useAppSelector.searchSubcategory;

  var _useQuerySaleCategori = useQuerySaleCategoriesSubcategories(),
      categoriesData = _useQuerySaleCategori.categoriesData,
      categoriesDataJSON = _useQuerySaleCategori.categoriesDataJSON,
      loading = _useQuerySaleCategori.loading;

  var _useCategoriesSubCate = useCategoriesSubCategories(id, categoriesData, categoriesDataJSON, loading, hideModal),
      setValues = _useCategoriesSubCate.setValues,
      values = _useCategoriesSubCate.values,
      handleSubCategoryValues = _useCategoriesSubCate.handleSubCategoryValues,
      initialStateCategory = _useCategoriesSubCate.initialStateCategory,
      subCategoryOptions = _useCategoriesSubCate.subCategoryOptions,
      handleCleanFilters = _useCategoriesSubCate.handleCleanFilters,
      submit = _useCategoriesSubCate.submit;

  return React.createElement(AlertFilters, {
    hideModal: hideModal,
    searchCategory: searchCategory,
    categoriesData: categoriesData,
    values: values,
    setValues: setValues,
    handleSubCategoryValues: handleSubCategoryValues,
    initialStateCategory: initialStateCategory,
    intl: intl,
    searchSubcategory: searchSubcategory,
    subCategoryOptions: subCategoryOptions,
    handleCleanFilters: handleCleanFilters,
    submit: submit
  });
};